import Vue, { Component } from 'vue';
import { Component as ComponentDecorator } from 'vue-property-decorator';
import CVueInstance from './CVueInstance';
import { mapActions } from 'vuex';

@ComponentDecorator({
  props: {
    colorClass: String,
    product: Object,
  },
})

export default class CubeProductListItem extends CVueInstance {
  private images: string[] | null = null;

  get myColorClass(): string {
    switch ((this as any).product.service) {
      case 'BetterFibre':
        return 'p-fibre';
    }
    return (this as any).colorClass;
  }

  markImagesAsLoaded(newImages: string[]) {
    this.$data.images = newImages;
    if (newImages.length > 1) {
      setTimeout(() => {
        (window as any).$(`#${this.GetMyId()}-images`).slick({
          speed: 500,
          infinite: true,
          dots: true,
          arrows: false,
          // fade: true,
          // cssEase: 'linear',
        });
      }, 100);
    }
  }

  getImageFromStore(dir: string, filename: string) {
    return new Promise((resolve, reject) => {
      this.$firebase.storage.ref(dir).child(filename).getDownloadURL().then(resolve).catch(reject);
      // this.$firebase.storage.ref(storeRef).getDownloadURL().then(resolve).catch(reject);
      // this.$firebase.storage.refFromURL(`gs://betterwebsite-3.appspot.com/${storeRef}`)
      //  .getDownloadURL().then(resolve).catch(reject);
    });
  }

  async mounted() {
    let newImages = [];
    for (const img of (this as any).product.images) {
      if (img.url !== undefined && img.url !== null) {
        newImages.push(img.url);
      } else if (img.store !== undefined && img.store !== null) {
        try {
          const imgUrl = await this.getImageFromStore('store.bettercorp.co.za', img.store);
          newImages.push(imgUrl);
        } catch (exc) {
          console.error(exc);
        }
      }
    }
    this.markImagesAsLoaded(newImages);
  }
}
